<template>
  <tr class="margin-bottom-20 goto-review" v-if="onPage === 'DefaultListing' && addGoToLink" @click="goToReview">
    <td class="is-size-7-mobile is-size-7-touch" v-text="friendlyDate(created_at, 'DD-MM-YYYY')"></td>
    <td class="is-hidden-mobile is-desktop hide-tablet-custom" v-text="friendlyDate(created_at, 'HH:mm')"></td>
    <td>
      <p class="name is-size-7-touch" v-html="author_name"></p>
    </td>
    <td class="is-hidden-mobile snipped-text is-size-7-touch">
      <span v-if="reported"><img src="/static/img/report.svg" width="20" height="20" class="is-pulled-left"/>&nbsp;&nbsp;</span>{{asText(title, 25) }}
    </td>
    <td class="is-size-7-mobile is-size-7-touch is-narrow-mobile">
      <rating :stars="reviewRating" :setRatingContWidth="setRatingContWidth"></rating>
    </td>
    <td class="is-size-7-mobile is-size-7-touch"><span v-if="replied" class="tag is-private is-rounded has-text-weight-bold">Replied</span></td>
    <td class="is-size-7-mobile is-size-7-touch has-text-right">
      <a :href="showReviewDetail" data-track="view review" v-if="showDetailsButton && !isReportItem" :class="['button is-button-blue is-button-small is-hidden-touch', { 'btn-outline': btnOutline}]" v-text="buttonCopy"></a>
      <a :href="showReviewDetail" data-track="view review" v-if="showDetailsButton" class="button-mobile-table is-button-blue is-hidden-desktop circle-border"><i class="fas fa-arrow-right"></i></a>
    </td>
  </tr>

  <tr class="margin-bottom-20 goto-review" v-else-if="onPage === 'BizReviewsListing' && addGoToLink"> <!-- @click="goToReview"-->
    <td class="is-size-7-mobile is-size-7-touch is-narrow">
      <label class="checkbox is-size-6 label-filters">
        <input
          type="checkbox"
          class=""
          :value="data.id"
          :checked="reviews.includes(this.data.id)"
          @change="handleCheckboxForBizReviewList"
        >
        <span class="checkmark"></span>
      </label>
    </td>
    <td class="is-size-7-mobile is-size-7-touch">
      <span class="date-span">{{ friendlyDate(created_at, 'DD-MM-YYYY') }}&nbsp;<span class="is-hidden-mobile is-size-10-pt">{{ friendlyDate(created_at, 'HH:mm') }} </span></span>
    </td>

    <td>
      <p class="is-size-7-touch reviewer-col" @click="goToReview">
        <span class="name">{{ author_name }}</span>&nbsp;<span class="is-hidden-mobile">{{ email }}</span>
      </p>
    </td>

    <td class="snipped-text is-size-7-touch is-hidden-mobile" @click="goToReview">
      <span v-if="reported"><img src="/static/img/report.svg" width="20" height="20" class="is-pulled-left"/>&nbsp;&nbsp;</span>{{ asText(title, 25) }}
    </td>
    <td class="is-hidden-touch">{{ data.author_ip_address }}</td>
    <td class="is-hidden-touch">{{ data.source }}</td>
    <td class="is-size-7-mobile is-size-7-touch"><span v-if="replied" class="tag is-private is-rounded has-text-weight-bold reply">Replied</span></td>

    <td class="is-size-7-mobile is-size-7-touch is-narrow-mobile reviewer-col">
      <span v-if="statusId === 1">Active</span>
      <span v-else-if="statusId === 2">Deleted</span>
    </td>
    <td class="is-hidden-mobile">
      <span :class="getNPSClass(data.nps_rating)">{{data.nps_rating}}</span>
    </td>
  </tr>

  <tr @click="goToBusinessReview" class="margin-bottom-20" v-else>
    <template v-if="isReportItem">
      <td class="is-size-7-mobile is-size-7-touch is-hidden-mobile" v-text="friendlyDate(created_at, 'DD-MM-YYYY')"></td>
      <td class="is-size-7-mobile is-size-7-touch is-hidden-tablet" v-html="friendlyDate(created_at, 'DD-MM-YYYY', mobileHyphenNoBreak)"></td>
      <td class="is-hidden-mobile is-desktop hide-tablet-custom" v-text="friendlyDate(created_at, 'HH:mm')"></td>
    </template>
    <template v-else>
      <td class="is-size-7-mobile is-size-7-touch is-hidden-mobile">
        <span v-text="friendlyDate(created_at, 'DD-MM-YYYY')"></span>
        <span v-text="friendlyDate(created_at, 'HH:mm')"></span>
      </td>
      <td class="is-size-7-mobile is-size-7-touch is-hidden-tablet" v-html="friendlyDate(created_at, 'DD-MM-YYYY', mobileHyphenNoBreak)"></td>
    </template>
    <td class="name is-size-7-touch is-hidden-mobile author-col" :class="{'snipped-text':!isReportItem}" v-html="author_name"></td>
    <td class="name is-size-7-mobile is-mobile is-hidden-tablet author-col" :class="{'snipped-text':!isReportItem}">
      <i class="fas fa-flag yellow clickable tooltip-target b3" v-if="data.business_reporting"></i>
      {{author_name}}
    </td>
    <td class="is-hidden-mobile snipped-text is-size-7-touch toolmain">
      <span class="review-text"> <span v-if="reported"><img src="/static/img/report.svg" width="20" height="20" class="is-pulled-left"/>&nbsp;&nbsp;</span>
      <i @mouseover="showTooltip = !showTooltip" @mouseleave="showTooltip = !showTooltip" class="fas fa-flag yellow flag-align" v-if="isReviewReported"></i>{{title }}</span>
      <div class="toltipnew total-clicks-tooltip" v-if="false">
        <div class="tooltip-innernew">
          <p>This review was reported on {{data.business_reporting.created_at | reportedDate}} <br> Read more about reporting reviews <a href="#">here</a>.</p>
        </div>
      </div>
    </td>
    <td class="is-size-7-mobile is-size-7-touch is-narrow-mobile is-hidden-mobile">
      <rating :stars="reviewRating" :setRatingContWidth="setRatingContWidth" :text-on-touch="!isReportItem"></rating>
    </td>
    <td class="is-size-7-mobile is-size-7-touch is-narrow-mobile is-hidden-tablet">
      <rating :stars="reviewRating" :setRatingContWidth="!setRatingContWidth" :text-on-touch="!isReportItem" :shrink-more="setRatingContWidth"></rating>
    </td>
    <td class="is-hidden-mobile" :class="{'is-hidden-tablet-only':!isReportItem}" v-if="canShowNPSRating">
      <span :class="getNPSClass(data.nps_rating)">{{data.nps_rating}}</span>
    </td>
    <td class="is-size-7-mobile is-size-7-touch" :class="{'is-hidden-mobile':!isReportItem}"><span v-if="replied" class="tag is-private is-rounded has-text-weight-bold reply">Replied</span></td>
    <td class="is-size-7-mobile is-size-7-touch has-text-right is-hidden-mobile">
      <template v-if="showDetailsButton">
        <a v-if="!isReportItem" :href="showReviewDetail" data-track="view review" class="has-text-underlined color-2aabe1 f12 is-hidden-touch" v-text="buttonCopy"></a>
        <a v-else :href="showReviewDetail" data-track="view review" :class="['button is-button-blue is-button-small is-hidden-touch', { 'btn-outline': btnOutline}]" v-text="buttonCopy"></a>

        <a :href="showReviewDetail" data-track="view review" class="button-mobile-table is-button-blue is-hidden-desktop circle-border"><i class="fas fa-arrow-right"></i></a>
      </template>
    </td>
  </tr>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import moment from 'moment'
  import Rating from '../../components/Rating'
  import qs from 'qs'
  import misc from '../../mixins/misc.js'

  export default {
    name: 'business-review-item',
    mixins: [misc],
    components: { Rating },
    data () {
      return {
        id: this.data.id,
        created_at: '',
        author_name: '',
        title: '',
        reviewRating: 0,
        permalink: '',
        replied: false,
        reported: false,
        email: null,
        statusId: null,
        reportedStatus: ['REPORTED', 'IN_PROGRESS', 'RE_OPENED'],
        mobileHyphenNoBreak: true,
        showTooltip: false
      }
    },
    created () {
      if (this.data.author) {
        if (this.checkReportStatus) {
          this.reported = this.data.is_reported
        }
        this.created_at = this.data.created_at
        this.author_name = this.data.authorDisplayName
        this.email = this.data.email
        this.title = this.data.review_title
        this.reviewRating = this.data.review_rating
        this.permalink = this.data.permalink
        this.statusId = this.data.status_id
      }
      this.replied = this.data.replied === 1
    },
    props: {
      filterSearch: {
        type: String
      },
      keyword: {
        type: String
      },
      buttonCopy: {
        type: String,
        default: 'View'
      },
      data: {
        type: Object,
        default: {}
      },
      btnOutline: {
        type: Boolean,
        default: false
      },
      showDetailsButton: {
        type: Boolean,
        default: true
      },
      setRatingContWidth: {
        type: Boolean,
        default: true
      },
      checkReportStatus: {
        type: Boolean,
        default: false
      },
      addClickEvent: {
        type: Boolean,
        default: false
      },
      businessSlugFromProp: {
        type: String,
        default: ''
      },
      isReportItem: {
        type: Boolean,
        default: false
      },
      onPage: {
        type: String,
        default: 'DefaultListing'
      },
      subscription: {
        type: Object
      },
      reviewIndex: {
        type: Number,
        default: 0
      },
      reviews: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    methods: {
      friendlyDate (dateString, dateFormat, noBreak = false) {
        if (noBreak) {
          return moment(dateString).format(dateFormat).replace(/-/g, '&#8209;')
        }
        return moment(dateString).format(dateFormat)
      },
      goToReview () {
        if (this.$route.query.hasOwnProperty('page')) {
          this.$router.push(`/business/${this.orgSlugFinal}/review/${this.permalink}/${this.id}?page=${this.$route.query.page}`)
        } else {
          this.$router.push(`/business/${this.orgSlugFinal}/review/${this.permalink}/${this.id}`)
        }
      },
      goToBusinessReview () {
        if (this.$route.query.hasOwnProperty('page')) {
          this.$router.push(`/review/${this.permalink}?page=${this.$route.query.page}`)
        } else {
          this.$router.push(`/review/${this.permalink}`)
        }
      },
      /**
       * Handle quick invite
       * @returns {void}
       **/
      handleCheckboxForBizReviewList (e) {
        window.events.$emit('inputFromReview', {
          review: this.data,
          value: e.target.value,
          checked: e.target.checked,
          reviewIndex: this.reviewIndex
        })
      }
    },
    computed: {
      orgSlugFinal () {
        if (this.businessSlugFromProp) {
          return this.businessSlugFromProp
        }
        return this.businessSlug
      },
      canShowNPSRating () {
        const allowedPlans = ['P1', 'P2', 'P3', 'P4', 'Pro', 'Enterprise']
        return typeof this.subscription !== 'undefined' && typeof this.subscription.name !== 'undefined' && (allowedPlans.indexOf(this.subscription.name) !== -1)
      },
      /**
       * return route for current clicked review
       * @returns {string}
       */
      showReviewDetail () {
        let keywordSearch = qs.stringify({keyword: this.keyword})
        let route = ''
        if (this.filterSearch !== undefined) {
          route = `/review/${this.permalink}?${keywordSearch}&${this.filterSearch}`
        } else {
          route = `/review/${this.permalink}?${keywordSearch}`
        }
        return route
      },
      addGoToLink () {
        return this.addClickEvent && this.orgSlugFinal !== ''
      },
      // Find whether review has reported or not
      isReviewReported () {
      if (this.data.business_reporting) {
        return this.reportedStatus.includes(this.data.business_reporting.status)
      }
        return false
      }
    },
    filters: {
      reportedDate (date) {
        return moment(date).format('DD-MM-YYYY hh:mm')
      }
    }
  }
</script>

<style scoped>
  .review_item {
    background-color: #f5f5f5;
    margin-bottom: 30px;
  }

  .name {
    font-weight: bold;
    font-size: 0.9rem;
  }

  .column, .column span {
    font-size: 11pt;
  }

  td.hide-tablet-custom {
    display: table-cell;
  }

  .tag.is-private {
    background-color: #c4cbd1;
    color: #58595b;
    font-size: 0.65rem;
  }

  .content table td, .content table th {
    vertical-align: middle!important;
  }

  tr.goto-review {
    cursor: pointer;
  }
  .date-span {
    width: 120px;
    display: block;
    font-size: 10pt !important;
  }
  .reviewer-col span {
    font-size: 10pt;
  }
  .is-size-10-pt {
    font-size: 10pt !important;
  }

  .snipped-text {
    max-width: 165px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .author-col {
    max-width: 123px;
  }
  /**/
  .v-popover{
    height: 0% !important;
  }
  .tooltip.popover .tooltip-inner{
    text-align: center;
    height: 0%;
    border-radius: 60px;
  }
  .clickable {
    cursor: pointer;
  }
  div.clickable {
    padding: 2px;
    margin-top:-16px;
  }
  .clickable p {
    /*color: #58595b;*/
  }
  .toltipnew {
    position: relative;
    width: 275px;
    -webkit-box-shadow: 0px 0px 25px 1px #989898;
    box-shadow: 0px 0px 25px 1px #989898;
    border-radius: 7px;
    left: 0px;
    background: #f9f9f9;
    text-align: center;
    left: -7px;
    z-index: 9999;
    top: 0px;
  }
  .toltipnew a{
    min-width:150px;
    margin-top:10px;
  }
  .hovernwe:hover .toltipnew{
    display:flex;
    align-items: center;
    justify-content:center;
    color: black;
    padding: 10px;
  }
  .toltipnew:before {
    content: "\F0D7";
    font-family: "Font Awesome 5 Free";
    position: absolute;
    width: 20px;
    height: 20px;
    top: -8px;
    left: 0px;
    right: 0;
    font-weight: 900;
    transform: rotate(-180deg);
    color: #fff;
    font-size: 20px;
  }
  .total-clicks-tooltip {
    top: 40px;
    left: 2px;
  }
  .tooltip-innernew {
    color: black;
    padding: 10px;
    font-size: 12px;
  }
  .tablcl td{
    overflow: inherit !important;
  }
  .tablcl td span{
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display:inline-block;
  }
  .toolmain{
    position:relative
  }
  .toolmain .toltipnew{
    position: absolute;
  }
  .toolmain i{
    position:relative;top:-4px;
  }
  .reply {
    padding-top: 3px;
  }
  /**/
  @media screen and (min-width: 768px) {
    .author-col {
      max-width: 135px;
    }
  }

  @media screen and (min-width: 1024px) {
    .snipped-text {
      max-width: 200px;
    }

    .author-col {
      max-width: 150px;
    }
  }

  @media screen and (max-width: 768px) {
    td.hide-tablet-custom {
      display: none;
    }
  }
  .review-text {
    width: 209px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .flag-align {
    top: 0px !important;
    padding-right: 4px;
  }

  /* Create a custom checkbox Begins */
  .goto-review input[type="checkbox"] {
    visibility: hidden;
  }
  .checkmark {
    position: absolute;
    top: 4px;
    left: 0;
    height: 10px;
    width: 10px;
    background-color: #fff;
    border: solid 1px #707070;
  }
  /* On mouse-over, add a grey background color */
  .label-filters:hover input ~ .checkmark {
    background-color: #fff;
  }
  /* When the checkbox is checked, add a blue background */
  .label-filters input:checked ~ .checkmark {
    border: none;
    background-color: #30aae1;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the checkmark when checked */
  .label-filters input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .label-filters .checkmark:after {
    left: 3px;
    top: 0px;
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  /* Create a custom checkbox Ends */
</style>



// WEBPACK FOOTER //
// src/pages/reviews/BusinessReviewItem.vue